import { render, staticRenderFns } from "./IndicadoresEstructuraPagination.vue?vue&type=template&id=1cfa0408&"
import script from "./IndicadoresEstructuraPagination.vue?vue&type=script&lang=js&"
export * from "./IndicadoresEstructuraPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports